/* angular:styles/component:css;257e87e5d8ee7c1f;/home/runner/work/app/app/src/app/components/local-files-grant-banner/local-files-grant-banner.component.ts */
:host {
  --crwd-notice-action-bg: var(--color-accent, #4c17ca);
}
/*# sourceMappingURL=local-files-grant-banner.component-XLBTX3WF.css.map */
